// material-ui
import { Grid } from '@material-ui/core';
import React from 'react';

// api
import { getContextualSegmentByID, IContextualSegment } from '~/src/dash/api/contextual-segments';
// other
import { IStore } from '~/src/dash/reducers/store';
import {
  extractRouteParams,
  navigate,
  parseLocation,
  RouteContextualSegmentSettingsList,
} from '~/src/dash/router/routes';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
// utils
import { decorate } from '~/src/dash/utils/decorator';
// views
import { ContextualSegmentSettingsView } from '~/src/dash/views/contextual-segments/contextual-segment-settings-view';
import { LoadingView } from '~/src/dash/views/loading-view';
import { SnackbarView } from '~/src/dash/views/snackbar-view';

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {}

interface IState {
  currentContextualSegment?: IContextualSegment;
  snackbarMessage: string;
  snackbarError: boolean;
  loaded: boolean;
}

export const ContextualSegmentSettingsExistingView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = {
      currentContextualSegment: undefined,
      snackbarMessage: '',
      snackbarError: false,
      loaded: false,
    };

    componentDidMount() {
      this.getContextualSegment();
    }

    componentDidUpdate(prevProps: Readonly<IProps>) {
      if (prevProps.location.pathname !== this.props.location.pathname) {
        this.getContextualSegment();
      }
    }

    getContextualSegment(): void {
      const loc = parseLocation(this.props.location.pathname);

      if (loc.contextual) {
        getContextualSegmentByID(this.props.session.publisher.ID, loc.contextual)
          .then((resp) => {
            this.setState({
              currentContextualSegment: resp[0],
              loaded: true,
            });
          })
          .catch(() => {
            this.setState(
              {
                snackbarMessage:
                  "You don't have access to this resource or it does not exist. Please create a new one or select one from the list.",
                snackbarError: true,
                loaded: false,
              },
              () => {
                setTimeout(() => {
                  navigate(
                    RouteContextualSegmentSettingsList,
                    extractRouteParams({
                      session: this.props.session,
                      user: this.props.user,
                    }),
                  );
                }, 3000);
              },
            );
          });
      }
    }

    handleCloseSnackbar = (): void => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
      });
    };

    render() {
      const { loaded, currentContextualSegment, snackbarMessage, snackbarError } = this.state;
      if (loaded) {
        return (
          <Grid>
            <ContextualSegmentSettingsView
              currentContextualSegment={currentContextualSegment}
              readOnly={false}
            />
            <SnackbarView
              open={!!snackbarMessage}
              error={!!snackbarError}
              onClose={this.handleCloseSnackbar}
            >
              {snackbarMessage}
            </SnackbarView>
          </Grid>
        );
      } else {
        return <LoadingView active={true} text='Loading the contextual segment settings' />;
      }
    }
  },
);
